<template>
    <div class="core">
        <div class="layui-fluid">
          <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="备件表.xlsx">
              <button class="layui-btn" title="新增备件" @click="add" style="margin-left:10px" v-if="this.security.hasAuth('repariPart_add')">
                <i class="layui-icon">&#xe624;</i>
                新增备件
              </button>
           </pub-search>
                <layui-table
                  ref="repairPartTable"
                  table-name="YW_REPAIR_PART"
                  :sort="['REPAIR_PART_NAME,REPAIR_PART_MODEL,REPAIR_PART_SERIAL:DESC']"
                  :page-size="20"
                  :page-range="6"
                  :page-options="[10, 20, 50, 100]"
                  :skin="'line'"
                  @table-event-edit="edit($event)"
                  @table-event-del="$refs.repairPartTable.delRows($event.data)">
                >
                  <div>
                      <div checkbox="true" align="center" fixed="left" width="60"></div>
                      <!-- <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div> -->
                      <layui-tableconfig :config = "tableList"></layui-tableconfig>
                      <div rowspan="3" align="center" fixed="right" title="操作" width="130">
                          <script type="text/html" v-pre>
                            {{#  if(d._mark.indexOf("repairPart_edit") > -1){ }}
                              <a class=" layui-btn-xs" lay-event="edit">编辑</a>
                            {{#  } }}
                            {{#  if(d._mark.indexOf("repairPart_del") > -1){ }}
                              <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del">删除</a>
                            {{#  } }}
                          </script>
                      </div>
                  </div>
              </layui-table>
        </div>
        <!-- <gs-form v-if="gsFormShow" :visible.sync="gsFormShow" :formType="gsFormType" :formData="gsFormData"/> -->
        <repair-part-form v-if="formShow" :visible.sync="formShow" :formType="formType" :formData="formData"/>
    </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import repairPartForm from "./repairPartForm.vue"

export default {
  name: 'repairPart',
  components: {
    repairPartForm
  },
  data () {
    return {
      tableObj: {
          checkedRows: 0,
          queryObject: {}
      },
        tableList:[
          { field: 'REPAIR_PART_TYPE_DESC', title: '备件类型'},
          { field: 'CLIENT_ID_DESC', title: '客户名称' },
          { field: 'BRAND_ID_DESC', title: '品牌名称' },
          { field: 'REPAIR_PART_NAME', title: '备件名称'},
          { field: 'REPAIR_PART_MODEL', title: '型号'},
          { field: 'REPAIR_PART_SERIAL', title: '序列号'},
          { field: 'REPAIR_PART_MONEY', title: '金额' },
          { field: 'REPAIR_PART_STORE_DESC', title: '仓库' },
          // { field: 'REPAIR_PART_CATEGORY_DESC', title: '类别' },
          { field: 'REPAIR_PART_RECOVERY_DESC', title: '回收备件' },
          { field: 'REPAIR_PART_REMARK', title: '备注' }
        ],
        searchConfig: {
          basic: [
            { TYPE:'input', WIDTH: 260,  FIELD: 'REPAIR_PART_NAME:2,REPAIR_PART_MODEL:2,REPAIR_PART_SERIAL:2,REPAIR_PART_MONEY:2,REPAIR_PART_CATEGORY:2,REPAIR_PART_RECOVERY:2', PLACEHOLDER: '请输入搜索条件'},
          ],
          advanced: [
            { TYPE:'input', NAME: '备件名称 :', FIELD:'REPAIR_PART_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '型号 :', FIELD:'REPAIR_PART_MODEL:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '序列号 :', FIELD:'REPAIR_PART_SERIAL:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'layui-multiselect', NAME: '仓库:', FIELD: 'REPAIR_PART_STORE:1',textField: 'text', valueField: 'value',initData:this.dict.getData('REPAIR_PART_STORE'),},
            { TYPE:'layui-multiselect', NAME: '类别:', FIELD: 'REPAIR_PART_CATEGORY:1',textField: 'text', valueField: 'value',initData:this.dict.getData('REPAIR_PART_CATEGORY'),},
            { TYPE:'layui-multiselect', NAME: '回收备件:', FIELD: 'REPAIR_PART_RECOVERY:1',textField: 'text', valueField: 'value',initData:this.dict.getData('REPAIR_PART_RECOVERY'),},
          ]
        },
        formShow: false,
        formType: null,
        formData: null,
    }
  },
  mounted() {
    this.tableObj = this.$refs.repairPartTable;
    this.tableObj.load();
  },
  methods: {
    /**
     * 编辑表格
     */
    edit($event){
      this.formType = 'edit';
      this.formData = $event.data
      this.formShow = true;
    },
    search() {
        this.tableObj.load()
    },
    reset() {
      this.tableObj.queryObject = {}
        this.tableObj.load()
    },
       /**
     * 新增备件
     */
    add () {
      this.formShow = true;
      this.formType = 'add';
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/repairPart/index.vue